export default "__VITE_ASSET__BJiElHeI__"